/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.ReferenceDataController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { CorrespondencePreferenceType } from '../models/correspondence-preference-type';
import { Country } from '../models/country';
import { DuoCertificateType } from '../models/duo-certificate-type';
import { ListedCertificate } from '../models/listed-certificate';
import { MaatregelCategorieModel } from '../models/maatregel-categorie-model';
import { MentionType } from '../models/mention-type';
import { MetaProductModel } from '../models/meta-product-model';
import { Nationality } from '../models/nationality';
import { PreApprovedCertificate } from '../models/pre-approved-certificate';
import { ProfessionalGroup } from '../models/professional-group';
import { ProfessionalGroupValidity } from '../models/professional-group-validity';
import { ProfessionalPosition } from '../models/professional-position';
import { ReasonCancellationRegistration } from '../models/reason-cancellation-registration';
import { SpecialismType } from '../models/specialism-type';
import { SystemParameter } from '../models/system-parameter';

@Injectable()
export class ReferenceDataApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }

    public professionalGroups(spinnerMessage: string = null): Observable<ProfessionalGroup[]> {
        return this.httpClient.get<ProfessionalGroup[]>(`/api/referencedata/professionalgroups`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public professionalGroupValidities(spinnerMessage: string = null): Observable<ProfessionalGroupValidity[]> {
        return this.httpClient.get<ProfessionalGroupValidity[]>(`/api/referencedata/professionalgroupvalidities`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public specialismTypes(spinnerMessage: string = null): Observable<SpecialismType[]> {
        return this.httpClient.get<SpecialismType[]>(`/api/referencedata/specialismtypes`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public mentionTypes(spinnerMessage: string = null): Observable<MentionType[]> {
        return this.httpClient.get<MentionType[]>(`/api/referencedata/mentiontypes`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public countries(spinnerMessage: string = null): Observable<Country[]> {
        return this.httpClient.get<Country[]>(`/api/referencedata/countries`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public nationalities(spinnerMessage: string = null): Observable<Nationality[]> {
        return this.httpClient.get<Nationality[]>(`/api/referencedata/nationalities`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public listedCertificates(spinnerMessage: string = null): Observable<ListedCertificate[]> {
        return this.httpClient.get<ListedCertificate[]>(`/api/referencedata/listedcertificates`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public correspondencePreferenceTypes(spinnerMessage: string = null): Observable<CorrespondencePreferenceType[]> {
        return this.httpClient.get<CorrespondencePreferenceType[]>(`/api/referencedata/correspondencepreferencetypes`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public systemParameters(spinnerMessage: string = null): Observable<SystemParameter[]> {
        return this.httpClient.get<SystemParameter[]>(`/api/referencedata/systemparameters`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public professionalPositions(spinnerMessage: string = null): Observable<ProfessionalPosition[]> {
        return this.httpClient.get<ProfessionalPosition[]>(`/api/referencedata/professionalpositions`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public duoCertificateTypes(spinnerMessage: string = null): Observable<DuoCertificateType[]> {
        return this.httpClient.get<DuoCertificateType[]>(`/api/referencedata/duocertificatetypes`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public reasonCancellationRegistrations(spinnerMessage: string = null): Observable<ReasonCancellationRegistration[]> {
        return this.httpClient.get<ReasonCancellationRegistration[]>(`/api/referencedata/reasoncancellationregistrations`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public metaProducts(spinnerMessage: string = null): Observable<MetaProductModel[]> {
        return this.httpClient.get<MetaProductModel[]>(`/api/referencedata/metaproducts`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public judgmentProvisionCategories(spinnerMessage: string = null): Observable<MaatregelCategorieModel[]> {
        return this.httpClient.get<MaatregelCategorieModel[]>(`/api/referencedata/judgmentprovisioncategories`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

    public preApprovedCertificates(spinnerMessage: string = null): Observable<PreApprovedCertificate[]> {
        return this.httpClient.get<PreApprovedCertificate[]>(`/api/referencedata/preapprovedcertificates`,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }


}
